<template>
  <div class="checkbox" v-bind:class="{ disabled: isDisabled }">
  	<input type="checkbox" v-on:change="onChange()" v-bind:id="id"  v-bind:name="name" v-bind:checked="checked" v-bind:disabled="isDisabled" />
  	<label v-bind:for="id">{{ id }}</label>
  </div>
</template>


<script>
  export default {
    name: 'checkbox',
    props: ['id', 'name','action', 'checked', 'isDisabled'],
    methods: {
    	onChange: function() {
        EventBus.$emit('action', {action: this.action, value: this.checked })
    	}
    },
    data: function() {
      return {
      }
    }
  }
</script>

<style lang="scss">
.checkbox {
  label {
    @include font-milo-m(1em);
  }
}
</style>




// WEBPACK FOOTER //
// CheckBox.vue?4b83c90e